.name-wrapper {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  grid-column: 1 / span 3;
}

.day-name {
  font-weight: 400;
  font-size: 1.6rem;
  color: var(--color-texts-high-contrast);
  line-height: 2.4rem;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.center-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  gap: 1.6rem;
  justify-content: center;
}

.right-wrapper {
  position: absolute;
  min-width: max-content;
  margin-inline-start: 1.6rem;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
}

.left-wrapper {
  position: absolute;
  min-width: max-content;
  margin-inline-end: 1.6rem;
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
}

.day-text {
  color: var(--color-texts-high-contrast);
  line-height: 1.8rem;
}

.dod-text {
  @media screen and (max-width: 1130px) {
    padding-left: 0.8rem;
  }
}
